"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getResponsiveStepValues = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _reduceRight = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce-right"));

/**
 * Return a normalized set of responsive step values.
 *
 * This will always return an array. If input values is undefined, or an empty
 * array, then the default value array will be returned. The returned array
 * can only be empty if the `defaultValue` is not provided, or is an empty
 * array.
 *
 * Undefined values use the _next defined_ value in the array. Undefined
 * trailing values are discarded. So `[,,8,,16,,]` is equivalent to
 * `[8,8,8,16,16]`.
 */
var getResponsiveStepValues = function getResponsiveStepValues(values) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (values === undefined) {
    return defaultValue;
  }

  if (!(values instanceof Array)) {
    values = [values];
  }

  var defined = (0, _reduceRight.default)(values).call(values, function (acc, value, i) {
    if (value === undefined) {
      if (i === acc.length - 1) {
        acc.pop();
      } else {
        acc[i] = acc[i + 1];
      }
    }

    return acc;
  }, (0, _toConsumableArray2.default)(values));
  return defined.length > 0 ? defined : defaultValue;
};

exports.getResponsiveStepValues = getResponsiveStepValues;